import React from "react";
import classes from "./classes.module.scss";

type IProps = {}
export default class Text extends React.Component<IProps> {
	public render(): JSX.Element {
		return (
			<p className={classes["root"]}>
				{this.props.children}
			</p>
		);
	}
}
